import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { createKnowledgeDomain, updateKnowledgeDomain } from '../../services/school/knowledgedomains/knowledgeDomains';
import { useForm } from 'react-hook-form';
import { KnowledgeDomainType } from '../../types/KnowledgeDomain';
import { yupResolver } from '@hookform/resolvers/yup';
import toast from 'react-hot-toast';
import { routes } from '../../routes';
import { KnowledgeDomainFormValidation } from './KnowledgeDomainFormValidation';
import { Button, Card, Flex, Spinner } from '@radix-ui/themes';
import TextFieldComponent from '../../components/inputs/Textfield/TextfieldComponent';
import TextAreaFieldComponent from '../../components/inputs/TextAreafield/TextAreafieldComponent';
import { ChevronLeftIcon, EnterIcon } from '@radix-ui/react-icons';
import { useAppDispatch, useAppSelector } from '../../hooks/hooks';
import { resetKnowledgeDomainData } from '../../redux/slices/school/knowledgeDomain';

export const UpdateKnowledgeDomain = () => {
  const navigate = useNavigate();
  const mutation = useMutation({ mutationFn: updateKnowledgeDomain, mutationKey: "updateKnowledgeDomain" });
  const knowledgeDomainData = useAppSelector((state) => state.knowledgeDomain);
  const dispatch = useAppDispatch();
  const { control, handleSubmit, formState: { errors } } = useForm<KnowledgeDomainType>
    (
      {
        resolver: yupResolver(KnowledgeDomainFormValidation),
        defaultValues: knowledgeDomainData,
        mode: 'onBlur',
        reValidateMode: 'onBlur',
        shouldUseNativeValidation: false,
      }
    );
  const onSubmit = handleSubmit(async (data) => {
    try {
      const result = await mutation.mutateAsync(data);
      if (result) {
        toast.success("Dominio salvo!");
        navigate(routes.knowledgeDomains);
        dispatch(resetKnowledgeDomainData())
      }
    } catch (err: any) {
      toast.error(`${mutation.error ?? err?.message}`);
    }
  });
  const handleBack = () => {
    navigate(routes.knowledgeDomains);
    dispatch(resetKnowledgeDomainData())
  }
  return (
    <form onSubmit={onSubmit} noValidate>
      <Card size='1'>
        <Flex direction='column' gap='4'>
          <TextAreaFieldComponent name="description" label="Nome" control={control} errors={errors} fieldProps={{ placeholder: 'Nome' }} required={true} />
          <TextFieldComponent name="code" label='Código' control={control} errors={errors} fieldProps={{ placeholder: 'Código' }} required={true} />
          <Flex direction='row' gap='4' style={{ alignSelf: 'end' }}>
            <Button type="button" variant="soft" color="gray" onClick={handleBack} disabled={mutation.isLoading}>
              <ChevronLeftIcon /> Voltar
            </Button>
            <Button type="submit" disabled={mutation.isLoading} variant='surface'  >
              {mutation.isLoading ? <Spinner loading> <EnterIcon /></Spinner> : <EnterIcon />}
              Registar
            </Button>
          </Flex>
        </Flex>
      </Card>
    </form>
  );
}
